// extracted by mini-css-extract-plugin
module.exports = {"aboutMemmoHeader":"AboutMemmo_aboutMemmoHeader__uKLyz","aboutMemmoHeading":"AboutMemmo_aboutMemmoHeading__vvPAU"};